// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import cardImage1 from "../../../assets/hero/hero1.png";
// import cardImage2 from "../../../assets/hero/hero2.png";
// import svg1 from "../../../assets/hero/hero1.svg";
// import svg2 from "../../../assets/hero/hero2.svg";
// import svg3 from "../../../assets/hero/hero3.svg";
// import svg4 from "../../../assets/hero/hero4.svg";
// import arrow_down from "../../../assets/hero/arrow/arrow_down.svg";
// import arrow_up from "../../../assets/hero/arrow/arrow_up.svg";
// import hero from "../../../assets/WhatWeDo/hero.png";
// import "./style.module.css";

// const Hero = () => {
//   const [activeCards, setActiveCards] = useState([false, false, false, false]);
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [hoveredReadMore, setHoveredReadMore] = useState(null);

//   const cardData = [
//     {
//       src: cardImage1,
//       svgpicture: svg1,
//       title: "Suite Placement Services",
//       longText:
//         "We connect you with top-tier<br/> executives who drive strategic<br/> growth.Our focus is on finding<br/> leadership that",
//     },
//     {
//       src: cardImage1,
//       svgpicture: svg2,
//       title: "Learning & Development",
//       longText:
//         "We offer tailored training programs<br/> to enhance employee skills and foster professional growth. Empower your<br/> teams to achieve their full potential",
//     },
//     {
//       src: cardImage2,
//       svgpicture: svg3,
//       title: "Recruitment Search",
//       longText:
//         "Our recruitment experts find the<br/> right talent to meet your business<br/> needs. We ensure a seamless<br/> process from sourcing",
//     },
//     {
//       src: cardImage1,
//       svgpicture: svg4,
//       title: "Staff Outsourcing",
//       longText:
//         "We provide flexible staffing solutions<br/> to manage your workforce efficiently. From temporary to permanent, we<br/> ensure the right fit for your organization",
//     },
//   ];

//   const handleExpandClick = (index) => {
//     setActiveCards((prev) => {
//       const updated = [...prev];
//       updated[index] = !updated[index];
//       return updated;
//     });
//   };

//   return (
//     <div
//       className="hero-container mx-sm-3 pl-4 pr-4 pb-5"
//       style={{ backgroundImage: `url(${hero})` }}
//     >
//       <div className="row" style={{ paddingLeft: "10px" }}>
//         <div className="col-12 pl-sm-5 col-md-6 d-flex mt-3 pt-4 text-start align-items-center">
//           <div className="row pl-sm-4">
//             <h1 className="hero-title">Our Services</h1>
//             <h1 className="hero-subtitle">
//               Complete Workforce Solutions: Hire, Vet, and Grow
//             </h1>
//           </div>
//         </div>
//         <div className="col-12 col-md-6 py-sm-3 mt-sm-5 pl-sm-4 d-flex justify-content-center align-items-start">
//           <p className="hero-description">
//             Our dedication is to cultivate strategic human acumen,<br />
//             nurturing professional competence to unlock individual potential.
//           </p>
//         </div>
//       </div>

//       <div className="row pt-sm-4 d-flex justify-content-center pt-lg-5 mt-lg-2">
//         {cardData.map((card, index) => (
//           <div
//             key={index}
//             className="col-lg-3 col-md-4 col-sm-6 col-12 mt-5 pt-sm-1 d-flex justify-content-center"
//             onMouseEnter={() => setHoveredCard(index)}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <div
//               className={`hero-card ${
//                 activeCards[index] ? "expanded" : ""
//               }`}
//             >
//               <img
//                 className="hero-card-img"
//                 src={card.src}
//                 alt={card.title}
//               />
//               <div
//                 className={`hero-card-svg-container ${
//                   hoveredCard === index || activeCards[index] ? "active" : ""
//                 }`}
//               >
//                 <img
//                   src={card.svgpicture}
//                   alt="Services Icon"
//                   className={`hero-card-svg ${
//                     hoveredCard === index || activeCards[index] ? "active" : ""
//                   }`}
//                 />
//               </div>

//               <div className="hero-card-body">
//                 <h5 className="hero-card-title">{card.title}</h5>

//                 <div
//                   className={`hero-card-desc ${
//                     activeCards[index] ? "expanded" : ""
//                   }`}
//                 >
//                   <div
//                     dangerouslySetInnerHTML={{ __html: card.longText }}
//                   />
//                 </div>

//                 <div
//                   className="hero-card-read-more"
//                   onClick={() => handleExpandClick(index)}
//                   onMouseEnter={() =>
//                     !activeCards[index] && setHoveredReadMore(index)
//                   }
//                   onMouseLeave={() => setHoveredReadMore(null)}
//                 >
//                   <p
//                     className={`hero-card-read-more-text ${
//                       activeCards[index] || hoveredReadMore === index
//                         ? "active"
//                         : ""
//                     }`}
//                   >
//                     {activeCards[index] ? "READ LESS " : "READ MORE "}
//                     <span>
//                       {activeCards[index] ? (
//                         <img
//                           className="hero-card-arrow up"
//                           src={arrow_up}
//                           alt="Arrow Up"
//                         />
//                       ) : (
//                         <img
//                           className="hero-card-arrow down"
//                           src={arrow_down}
//                           alt="Arrow Down"
//                         />
//                       )}
//                     </span>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Hero;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import cardImage1 from "../../../assets/hero/hero1.png";
import cardImage2 from "../../../assets/hero/hero2.png";
import svg1 from "../../../assets/hero/hero1.svg";
import svg2 from "../../../assets/hero/hero2.svg";
import svg3 from "../../../assets/hero/hero3.svg";
import svg4 from "../../../assets/hero/hero4.svg";
import arrow_down from "../../../assets/hero/arrow/arrow_down.svg";
import arrow_up from "../../../assets/hero/arrow/arrow_up.svg";
import hero from '../../../assets/WhatWeDo/hero.png';
import style from "./style.module.css";
import { Subtitles } from "@mui/icons-material";

const Hero = () => {
  const { custom_container, bg_purple, slide_in, title, Subtitle,custom_row, description, card_read, arrow_img,div_description, Read_more, custom_card, customn_padding, custom_svg, custom_svgcard, card_title, card_desc, collapsed, expanded ,read_expand,read_collapsed,custom_title_padding} = style;
  const [hoveredReadMore, setHoveredReadMore] = useState(null);
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const [height, setHight] = useState('');

  const navigate = useNavigate();
  const [activeCards, setActiveCards] = useState([false, false, false, false]); // Track each card's expanded state
  const [hoveredCard, setHoveredCard] = useState(null); // Track the hovered card for background change
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };
    setHight(innerHeight - 301);
    // Add the resize event listener
    window.addEventListener("resize", handleResize);
    console.log(innerHeight)

    // Cleanup the listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);

    };
  }, [window.innerHeight]);
  const cardData = [ 
    { src: cardImage1, svgpicture: svg1, title: "Recruitment", longText: "Connect with the best talent to lead <br/> your team quickly and seamlessly Our <br/> tailored recruitment process ensures <br/> the right match between candidates and roles" },
    { src: cardImage1, svgpicture: svg4, title: "C-Level Placement", longText: " We offer top-tier hiring services for<br/> leadership and decision-making roles,<br/> helping organizations build strong, inclusive, and visionary teams" },
    { src: cardImage1, svgpicture: svg2, title: "Learning & Development", longText: "Customized training programs for employee development to unlock <br/> potential at every  level of<br/> your organization." },
    { src: cardImage2, svgpicture: svg3, title: "HR Compliance & Payroll Processing", longText: " Simplify your business operations with <br/> our efficient HR compliance. We handle <br/> the focus on  growing your business." },
    // { src: cardImage1, svgpicture: svg4, title: "Business Consulting", longText: "We focus on optimizing operations,<br/> enhancing unit economics, and helping you create a sustainable and<br/> profitable business model" },
  ];

  const handleExpandClick = (index) => {
    setActiveCards(prev => {
      const updated = [...prev];  
      updated[index] = !updated[index]; // Toggle the specific card
      return updated;
    });
  };
  // const handleExpandClick = (index) => {
  //   setActiveCards((prev) =>
  //     prev.map((isActive, i) => (i === index ? !isActive : false)) // Toggle the clicked card, collapse others
  //   );
  // };

  return (
    <div className={`mx-sm-3 pl-4  pr-4 ${bg_purple} ${custom_container} pb-5`}
      style={{
        backgroundImage: `url(${hero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: "#F8F8F4",
        borderRadius: "0 0 30px 30px",
        position: "relative",
        zIndex: 1,
        boxSizing: 'border-box'
      }}
    >
      <div className="row " style={{ paddingLeft: "10px" }}>
        <div className={`col-12 pl-sm-5 col-md-6 d-flex mt-3 pt-4 text-start  text-md-left align-items-center ${custom_title_padding} `}>
          <div className={`row pl-sm-4  ${custom_row}`}>
            <h1 className={`orange-color  ml-sm-2 ml-lg-4 pl-lg-3 ${slide_in} ${title}`} style={{

            }}>
              Our Services
            </h1>
            <h1 className={`my-2 my-lg-0 pt-lg-0   ml-sm-2 ml-lg-4 pl-lg-3 ${slide_in} pt-sm-3 text-start text-lg-start ${Subtitle}`}>
              Transform Your Dreams: <span className="hover_green" >Connect</span>, <span className="hover_green">Empower</span> and <span className="hover_green">Thrive</span>
            </h1>
          </div>
        </div>
        <div className={`col-12 col-md-6 py-sm-3 p-0 mt-sm-5 pl-sm-4 d-flex justify-content-center align-items-start ${div_description}`}>
          <p className={`text-sm-center ${slide_in} ${description} `} style={{

          }}>
             Our goal is to empower both businesses and employees to reach their full potential. As a women-led initiative, we are passionate about diversity and innovation and we aim to collaborate with a wide range of organizations- from government & semi-government entities to SME’s, high growth startups, and consultancies. We are here to help you drive success, foster lasting connections, and lead the way in the future of work.
          </p>
        </div>
      </div>

      <div className="row pt-sm-4 d-flex justify-content-center pt-lg-5 mt-lg-2">
        {cardData.map((card, index) => (
          <div key={index}
            className={`col-lg-3  col-md-3 col-sm-6 col-12 mt-5 pt-sm-1 pt-lg-2 
            d-flex justify-content-center ${customn_padding}`}
            onMouseEnter={() => setHoveredCard(index)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            {/* <div
             className={`hero-card ${
                activeCards[index] ? "expanded" : ""
              }`}
           > */}
            <div
              className={`card ${custom_card} ${activeCards[index] ? expanded : collapsed
                }`}
            
            >
              {/* <div className={`card custom_card `}
              style={{
                width: "400px",
                overflow: "hidden",
                backgroundColor: "#F8F8F4",
                position: "relative",
                height: activeCards[index] ? `set_Height` : "395px",
                transition: "height 0.3s ease",
              }}
            > */}
              <img className="card-img-top" src={card.src} alt={card.title} style={{ width: "100%" }} />
              <div className={`${custom_svgcard}`}
                style={{
                  position: "absolute",
                  backgroundColor: hoveredCard === index || activeCards[index] ? "#7A490C" : "#FFFFFF",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  border: hoveredCard === index || activeCards[index] ? "2px solid #7A490C" : "none",
                }}>
                <img src={card.svgpicture} alt="Services Icon"
                  className={`${custom_svg}`}
                  style={{
                    filter: hoveredCard === index || activeCards[index] ? "brightness(0) invert(1)" : "none",
                  }} />
              </div>

              <div className="card-body p-0   pt-lg-0 pt-3" style={{ backgroundColor: "#efddc7" }}>
                <h5 className={`card-title mt-5 pt-2  text-center ${card_title}`} style={{
                  fontFamily: "Montreal Medium,inherit",
                  // fontStyle:"normal"
                }}>{card.title}</h5>

                <div className={`card-text ml-1 pl-sm-4 pr-sm-4 pl-lg-2 pr-lg-1 mr-1 p-0 ${card_desc} ${activeCards[index] ? "expanded" : ""}`} style={{
                  maxHeight: activeCards[index] ? "112px" : "0",

                  overflow: "hidden",
                  transition: "max-height 0.3s ease",

                  textAlign: "center",

                }}>
                  {/* {card.longText} */}
                  <div dangerouslySetInnerHTML={{ __html: card.longText }} />

                </div>

                <div className={`${card_read}`}
                  style={{
                    // position: "absolute",
                    // bottom: "0px",
                    // left: "0",
                    // right: "24px",
                    // cursor: "pointer",
                    // display: "flex",
                    // alignItems: "end",
                    // justifyContent: "end",
                  }}
                  onClick={() => handleExpandClick(index)}
                  onMouseEnter={() => !activeCards[index] && setHoveredReadMore(index)}
                  onMouseLeave={() => setHoveredReadMore(null)}
                >
                  <p className={`${Read_more} ${activeCards[index] ? read_expand : read_collapsed}`} style={{
                  
                    color: activeCards[index] ? "#7A490C" : (hoveredReadMore === index ? "#04642d" : "#7A490C"),
                    textUnderlineOffset: "5px",
                    textDecoration: activeCards[index] || hoveredReadMore === index ? "none" : "underline",
                  }}>

                    {activeCards[index] ? "READ LESS " : "READ MORE "}{" "}
                    <span style={{
                      display: "inline-block",
                      fontSize: "1rem",
                      fontWeight: "bold",
                      color: activeCards[index] ? "#7A490C" : (hoveredReadMore === index ? "black" : "#7A490C"),
                      fontFamily: "Montreal Medium, inherit",
                      transition: "transform 0.3s ease",
                      textDecoration: activeCards[index] || hoveredReadMore === index ? "none" : "underline",
                    }}>
                      {activeCards[index] ? (
                        <img
                          className={`${arrow_img}`}
                          src={arrow_up}
                          alt="Arrow Up"
                          style={{
                            width: "11px",
                            transform: "rotate(-5deg)", // rotation for the up arrow
                            transition: "transform 0.3s ease",
                          }}
                        />
                      ) : (
                        <img
                          className={`${arrow_img}`}
                          src={arrow_down}
                          alt="Arrow Down"
                          style={{
                            width: "11px",
                            transform: "rotate(5deg)", // rotation for the down arrow
                            transition: "transform 0.3s ease",
                          }}
                        />
                      )}
                    </span>
                  </p>
                </div>

              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hero;
